import {useListView} from '../core/ListViewProvider'
import {ToursListToolbar} from './TourListToolbar'
import {ToursListGrouping} from './TourListGrouping'
import {ToursListSearchComponent} from './ToursListSearchComponent'

const ToursListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      <ToursListSearchComponent />
      <div className='card-toolbar ms-auto'>
        {selected.length > 0 ? <ToursListGrouping /> : <ToursListToolbar />}
      </div>
    </div>
  )
}

export {ToursListHeader}
